export default "https://cdn-static.gokick.com/assets/392c20f622263512bf2611e9ba1d645afacce893/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";